/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
// component
import PasswordReset from 'pages/auth/passwordreset/passwordreset';



/* ========== ~~~~~~~~~~ AUTH PASSWORD RESET : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ sessionStatus, appStatus, authStatus }) => ({
    appStatus: appStatus,
    email: authStatus.resetpassword.fields.email.value
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordReset);
